module.exports = __webpack_public_path__ + "static/media/shopping-bag-selected.fa4843b7.svg";